import {CustomCategory, EventType} from "src/utils/analytics/constants";

type RedirectEventData = {
  typeId: EventType;
  email: string;
  viewId?: string;
  flowId?: string | null;
  nextButtonText?: string;
};

export const buildEmailRedirectData = ({
  typeId,
  email,
  viewId,
  flowId,
  nextButtonText,
}: RedirectEventData) => {
  if (typeId === EventType.EmailCheckClicked) {
    return {
      typeId: EventType.EmailCheckClicked,
      extraData: {
        category: CustomCategory.AppointmentScheduling,
        value: nextButtonText,
        viewId,
        flowId,
      },
    };
  }

  return {
    typeId: EventType.DirectToPatientAppStarted,
    extraData: {
      category: CustomCategory.AppointmentScheduling,
      emailEntered: email,
      flowId,
    },
  };
};
